import { render, staticRenderFns } from "./queryform2.vue?vue&type=template&id=3c4ec352&scoped=true&"
import script from "./queryform2.vue?vue&type=script&lang=js&"
export * from "./queryform2.vue?vue&type=script&lang=js&"
import style0 from "./queryform2.vue?vue&type=style&index=0&id=3c4ec352&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4ec352",
  null
  
)

export default component.exports